@if (isLoading()) {
  <div class="loading-container">
    <oui-loading></oui-loading>
  </div>
} @else {
  <oui-date-picker
    label="Date de début de validité"
    placeholder="JJ/MM/AAAA"
    [control]="form.get('dateDebutValidite')"
    [errors]="dateValidationErrors"
    (valueChange)="setDateFinDeValidite($event)"></oui-date-picker>

  @if (isSociete()) {
    <span class="subtitle-2">Adresse</span>
    <div class="oui-form-line">
      <lib-adresse-autocomplete
        class="oui-form-field-lg"
        [control]="form.get('voie')!"
        (addressChange)="onAdressSelect($event)">
      </lib-adresse-autocomplete>
    </div>
    <oui-textfield
      label="Code postal"
      [regexFilter]="numbersRegex"
      [control]="form.get('codePostal')"></oui-textfield>
    <oui-textfield label="Ville" [control]="form.get('ville')"></oui-textfield>
    <oui-select
      label="Pays"
      [options]="countriesOptions()"
      [control]="form.get('pays')"></oui-select>

    <span class="subtitle-2">Société</span>
    <oui-textfield
      label="Raison sociale"
      [control]="form.get('raisonSociale')"></oui-textfield>
    <oui-select
      label="Type de société"
      [options]="formeJuridiqueOptions"
      [control]="form.get('formeJuridique')"></oui-select>
  } @else {
    <span class="subtitle-2">Profession Liberale</span>
  }

  <oui-textfield
    [regexFilter]="numbersRegex"
    label="N° SIREN"
    [control]="form.get('numeroSiren')"
    [errors]="sirenErrors"></oui-textfield>
  <div class="infosbulle-field oui-form-field-md">
    <oui-textfield
      [regexFilter]="numbersRegex"
      label="N° SIRET"
      [control]="form.get('numeroSiret')"
      [errors]="siretErrors"></oui-textfield>
    <oui-infos-bulle bulleTitle="SIRET">
      Le SIRET est composé de 14 chiffres : le numéro SIREN figurant sur le KBIS suivi du
      NIC, un numéro à 5 chiffres identifiant l'établissement et généralement commençant
      par 000</oui-infos-bulle
    >
  </div>
  <oui-textfield
    label="N° TVA intracommunautaire"
    placeholder="Ex. : FR12 345678901"
    [control]="form.get('numeroTva')"
    [errors]="tvaIntra"></oui-textfield>
  <oui-textfield
    label="Capital Social"
    [control]="form.get('capitalSocial')"></oui-textfield>
  <oui-textfield
    label="Ville registre du commerce (RC)"
    [control]="form.get('villeRegistreCommerce')"></oui-textfield>
}
